import { Component, Injector, Input, SimpleChanges, OnChanges } from '@angular/core';
import { Form } from 'src/app/services/forms/form';
import { WfSignatureResource, WfSignature, WFConfiguration } from 'src/app/components/workflow/workflow';
import { EbService } from '../../eb.service';
import { BaseComponent } from 'src/app/common/base/base.component';

@Component({
  selector: 'eb-main-s5',
  templateUrl: './eb-main-s5.component.html',
  styleUrls: ['./eb-main-s5.component.scss']
})
export class EbMainS5Component extends BaseComponent implements OnChanges {

  @Input() form?: Form | null;
  @Input() disabled!: boolean;
  @Input() showAmendment!: boolean;
  @Input() service?: EbService;


  wfSignatures?: WfSignatureResource[];
  signatures!: WfSignature[];

  configuration?: WFConfiguration[];

  visible?: boolean;

  ngOnChanges(changes: SimpleChanges): void {
    this.refresh();
  }

  refresh() {
    if (this.form) {
      // this.configuration = await this.workflowService.readConfiguration(9, this.form.wfTableID ?? 0).toPromise();

      // const leftPersons = [
      //   this.configuration?.filter(x => x.identificator == 111) ?? []];

      // const rightPersons = [
      //   this.configuration?.filter(x => x.identificator == 112) ?? []];

      this.wfSignatures = this.form?.wfTable?.wfTableLocal?.wfSectionLocals.find(s => s.number == 5)?.wfSignatures;

      const previousSigned = this.wfSignatures?.some(s => s.signedBy?.id == this.currentUser?.id);
      this.signatures = [];
      this.wfSignatures?.map(signature => {
        this.signatures.push(WfSignatureResource.transformSignature(signature, previousSigned));
      });
      this.visible = this.signatures.some(s => s.enabled);
    }
  }

  async approve(s: WfSignature) {
    const signed = await this.service?.confirmSign(this.form, s, s.approveActionId, '', undefined);
    if (!signed) this.refresh();
  }

}
